// 梁
import store from "@/store/index";
import rlModelData from "@/rlMxModules/rlDataClass/rlModelData";
import { getEntityData } from "@/rlMxModules/operate/operateApi";
import { McGePoint3d, McCmColor } from "mxcad";
import { rlTextData } from "./rlTextData";
import { getPKPM_BeamData } from "@/rlMxModules/Opencascad/getModelDrawData.js";
import {
  calculateDistanceAndAngle,
  calculateArcCenterByCenter,
} from "@/rlMxModules/operate/operateApi";
import {
  checkRelationGuidData,
  MovePt,
} from "@/rlMxModules/operate/structural";
import { getpickstatus } from "@/api/modelingList.js";
import { log } from "three";
class rlBeamData extends rlModelData {
  getModel3dData = store.state.globalData.rl_wasm_module.getModel3dData;
  // wasm接口方法
  // getPKPM_BeamData = store.state.globalData.rl_wasm_module.getPKPM_BeamData;
  constructor() {
    super();
    this.componentType = "beam";
    // 顶点数据
    this.points = [];
    this.deviation = 0.0001;
    this.m_gridData = {}; //网格数据
    this.Ecc = null; //梁偏轴距离
    this.HDiff1 = null; //梁顶标高1
    this.HDiff2 = null; //梁顶标高2
    this.Rotation = null; //轴转角

    this.Attribute = 1; //默认为主要构件
    this.classTypeName = "rlBeamSeg"; // 梁类型
    this._threeObj = null; //三维图形对象
    this.isSelect = false; //自定义是否选中标识
    // this.defaultColor = "#00b4b4"; //默认颜色
    this.Color = null;
    // (this.rlLayer && this.rlLayer[0] && this.rlLayer[0].storey) || "#00b4b4"; //构件颜色
    this.ModelType = "梁";
    //this.Layer = "rlBeamSeg"; //图层名称
    this.LinkGuids = []; //能合并为同一条梁的其他梁的guid
    this.m_groupName = "rlBeamGroup"; //组名

    //检测鉴定数据--配筋数据
    this.m_jcData = [];
    //排查--房间命名
    this.useFunctionNames = [];

    this.beamColor = null;
    this.subBeamColor = null;
    this.ringBeamColor = null;
    //同类构件中主构件的guid
    this.m_RelationGuid = null;
    //同类构件数据--临时保存文字
    this.m_HomogeneousData = [];
    this.m_HomogeneousTextStrData = null; //同类构件中主构件的文字位置偏移
    //检查构件文字--临时保存文字
    this.checkText = null;
  }

  //绘制同类构件文字
  drawHomogeneousData(data, isDisplay) {
    if (this.m_sectParamData.Mat != 6) {
      return;
    }
    if (!data) {
      if (this.m_HomogeneousTextStrData) {
        data = this.m_HomogeneousTextStrData;
      } else {
        return;
      }
    } else {
      this.m_HomogeneousTextStrData = data;
    }

    if (this.m_HomogeneousData && this.m_HomogeneousData.length) {
      this.eraseHomogeneousData();
    }
    let fontSize = store.state.platBtns.fontSize;
    //矩形梁
    if (this.m_sectParamData.Kind == 1) {
      let pt1 = new McGePoint3d(this.index2dData[0], this.index2dData[1], 0);
      let pt2 = new McGePoint3d(this.index2dData[3], this.index2dData[4], 0);
      let pt3 = new McGePoint3d(this.index2dData[6], this.index2dData[7], 0);
      let pt4 = new McGePoint3d(this.index2dData[9], this.index2dData[10], 0);
      let vec1 = new THREE.Vector3().subVectors(pt3, pt2).normalize();
      let vec2 = new THREE.Vector3().subVectors(pt2, pt3).normalize();
      if (data.reinforcement_report_area != null) {
        let { angle } = calculateDistanceAndAngle(pt1, pt2);
        if (angle == 180) angle = 0;
        if (angle == 270) angle = 90;
        //转换成弧度
        angle = angle * (Math.PI / 180);
        let textObj = new rlTextData();
        let position = new McGePoint3d(
          (pt1.x + pt2.x) / 2,
          (pt1.y + pt2.y) / 2,
          0
        );
        position = MovePt(position, vec2, fontSize);
        textObj.position = position;
        textObj.Text = data.reinforcement_report_area;
        textObj.fontSize = fontSize;
        textObj.dAngle = angle;
        textObj.textType = "配筋数据文字";
        textObj.McDbText.setxDataString("Guid", this.Guid);
        textObj.McDbText.setxDataString("classTypeName", this.classTypeName);
        textObj.draw(isDisplay);
        this.m_HomogeneousData.push(textObj.mcDbId);
      }
      if (data.encrypted_report_area != null) {
        let { angle } = calculateDistanceAndAngle(pt4, pt3);
        if (angle == 180) angle = 0;
        if (angle == 270) angle = 90;
        //转换成弧度
        angle = angle * (Math.PI / 180);
        let textObj = new rlTextData();
        let position = new McGePoint3d(
          (pt4.x + pt3.x) / 2,
          (pt4.y + pt3.y) / 2,
          0
        );
        position = MovePt(position, vec1, fontSize);
        textObj.position = position;
        textObj.Text = "G" + data.encrypted_report_area;
        textObj.fontSize = fontSize;
        textObj.dAngle = angle;
        textObj.textType = "配筋数据文字";
        textObj.McDbText.setxDataString("Guid", this.Guid);
        textObj.McDbText.setxDataString("classTypeName", this.classTypeName);
        textObj.draw(isDisplay);
        this.m_HomogeneousData.push(textObj.mcDbId);
      }
    }
  }

  //删除同类构件文字
  eraseHomogeneousData() {
    if (this.m_HomogeneousData && this.m_HomogeneousData.length) {
      this.m_HomogeneousData.forEach((objId) => {
        objId?.getMcDbEntity().erase();
      });
      this.m_HomogeneousData = [];
    }
  }

  //绘制检查构件文字
  async drawCheckText() {
    if (
      store.state.cadModules.rlProject_detail.businessTypePermission ===
      "investigate"
    ) {
      return;
    }
    const { data } = await getpickstatus({
      project_id: store.state.cadModules.rlProject_id,
      flr_guid: store.state.cadModules.rlBuilding.Guid,
      guid: this.Guid,
    });
    if (this.checkText) {
      this.checkText.getMcDbEntity().erase();
    }
    if (!data || !data.status) {
      return;
    }
    let fontSize = store.state.platBtns.fontSize;
    const isShowBeam =
      (this.getCheckStatus(5) && this.Attribute == 1) ||
      (this.getCheckStatus(8) && this.m_sectParamData.IsRingBeamSeg == 1) || //圈梁
      (this.getCheckStatus(9) && this.Attribute == 2); //次梁
    const isCheckCheckText = this.getCheckStatus(25);
    let display = isShowBeam && isCheckCheckText;

    //矩形梁
    if (this.m_sectParamData.Kind == 1) {
      let pt1 = new McGePoint3d(...this.m_gridData.m_stJoint.m_pt);
      let pt2 = new McGePoint3d(...this.m_gridData.m_edJoint.m_pt);
      if (data.content) {
        let { angle } = calculateDistanceAndAngle(pt1, pt2);
        if (angle == 180) angle = 0;
        if (angle == 270) angle = 90;
        //转换成弧度
        angle = angle * (Math.PI / 180);
        let textObj = new rlTextData();
        textObj.position = new McGePoint3d(
          (pt1.x + pt2.x) / 2,
          (pt1.y + pt2.y) / 2,
          0
        );
        textObj.Text = "梁(检:" + data.content + ")";
        textObj.fontSize = fontSize;
        textObj.dAngle = angle;
        textObj.textType = "配筋数据文字";
        textObj.McDbText.setxDataString("Guid", this.Guid);
        textObj.McDbText.setxDataString("classTypeName", this.classTypeName);
        textObj.draw(display);
        this.checkText = textObj.mcDbId;
      }
    }
  }

  //删除检查构件文字
  eraseCheckText() {
    if (this.checkText) {
      this.checkText.getMcDbEntity().erase();
    }
  }

  //根据guid获取checkbox的点击状态
  getCheckStatus(guid) {
    return store.state.displayData.rlLayerDisplay.includes(guid);
  }

  drawJcData(jcDataObj, bShow, showType /*1==序号，2==配筋 */) {
    if (this.m_jcData && this.m_jcData.length) {
      this.eraseJcData();
    }
    if (this.m_sectParamData.Mat != 6 || !jcDataObj) {
      return;
    }

    let fontSize = store.state.platBtns.fontSize;
    //计算网格线
    let pt1 = new McGePoint3d(
      this.m_gridData.m_stJoint.m_pt[0],
      this.m_gridData.m_stJoint.m_pt[1],
      0
    );
    let pt2 = new McGePoint3d(
      this.m_gridData.m_edJoint.m_pt[0],
      this.m_gridData.m_edJoint.m_pt[1],
      0
    );
    let isArc = this.m_gridData.m_centerJoint != null;
    let swapFlag = false;
    if (pt1.x > pt2.x || pt1.y > pt2.y) {
      [pt1, pt2] = [pt2, pt1];
    }
    const lineOrigin = new THREE.Line3(
      new THREE.Vector3(pt1.x, pt1.y, 0),
      new THREE.Vector3(pt2.x, pt2.y, 0)
    );
    const gridVec = new THREE.Vector3();
    lineOrigin.delta(gridVec);
    gridVec.normalize();
    //若gridVec方向指向左下，则取反--仅考虑垂直方向
    if (Math.abs(gridVec.x + 1) < 0.1 || Math.abs(gridVec.y + 1) < 0.1) {
      gridVec.multiplyScalar(-1);
    }

    //计算gridVec的垂直方向
    let gridVecPrep = new THREE.Vector3();
    gridVecPrep.crossVectors(gridVec, new THREE.Vector3(0, 0, 1));
    let ptCenter = new McGePoint3d((pt1.x + pt2.x) / 2, (pt1.y + pt2.y) / 2, 0);

    //计算角度
    var angle = gridVec.angleTo(new THREE.Vector3(1, 0, 0));
    if (isArc) {
      // if (this.Guid == "6A86673D-E78A-46DF-98CB-81F196850DD5") debugger;

      if (this.Guid == "621E074E-39B1-4EA1-9912-0F6B379CECB4") debugger;
      let ptCircle = new THREE.Vector3(...this.m_gridData.m_centerJoint.m_pt);

      gridVecPrep = new THREE.Vector3(
        ptCircle.x - ptCenter.x,
        ptCircle.y - ptCenter.y,
        0
      );
      gridVecPrep.normalize();
      if (gridVecPrep.x >= Math.exp(-2)) {
        gridVec.crossVectors(
          new THREE.Vector3(-gridVecPrep.x, -gridVecPrep.y, 0),
          new THREE.Vector3(0, 0, 1)
        );
      } else gridVec.crossVectors(gridVecPrep, new THREE.Vector3(0, 0, 1));
      angle = gridVec.angleTo(new THREE.Vector3(1, 0, 0));
      if (gridVecPrep.x <= Math.exp(-2)) {
        angle += Math.PI;
      }
      if (gridVecPrep.y > Math.exp(-2)) {
        angle += Math.PI;
      }
      if (gridVecPrep.y < Math.exp(-2)) {
        swapFlag = true;
      }

      let radian = ptCircle.distanceTo(pt1);

      ptCircle.x -= gridVecPrep.x * radian;
      ptCircle.y -= gridVecPrep.y * radian;
      ptCenter = ptCircle;
      if (gridVecPrep.y > Math.exp(-2)) {
        gridVecPrep.x = -gridVecPrep.x;
        gridVecPrep.y = -gridVecPrep.y;
      }
      //计算圆弧中心点
      // let tempCenterPoint = calculateArcCenterByCenter(
      //   new THREE.Vector3(...this.m_gridData.m_centerJoint.m_pt),
      //   pt1,
      //   pt2
      // );
      // if (tempCenterPoint) {
      //   ptCenter = tempCenterPoint;
      // }
    }

    if (jcDataObj.No != null) {
      let textObj = new rlTextData();
      textObj.position = ptCenter;
      textObj.Text = jcDataObj.No;
      textObj.fontSize = fontSize;
      textObj.dAngle = angle;
      textObj.draw(showType == 1);
      textObj.textType = "计算结果";
      this.m_jcData.push(textObj.mcDbId);
    }

    if (jcDataObj.Asv && jcDataObj.Asv0) {
      let textObj = new rlTextData();
      let x = ptCenter.x - (gridVecPrep.x * fontSize) / 2;
      let y = ptCenter.y - (gridVecPrep.y * fontSize) / 2;
      textObj.position = new McGePoint3d(x, y, 0); // new McGePoint3d(ptCenter.x, ptCenter.y + 200, 0);
      textObj.Text = "G" + jcDataObj.Asv + "-" + jcDataObj.Asv0;
      textObj.fontSize = fontSize;
      textObj.dAngle = angle;
      if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("1")) {
        textObj.color = new McCmColor(255, 0, 0);
      }
      textObj.textType = "计算结果";
      textObj.draw(showType == 2);
      this.m_jcData.push(textObj.mcDbId);
    }

    if (jcDataObj.Asu1 && jcDataObj.Asu2 && jcDataObj.Asu3) {
      let textObj = new rlTextData();
      let x = ptCenter.x + gridVecPrep.x * fontSize;
      let y = ptCenter.y + gridVecPrep.y * fontSize;
      textObj.position = new McGePoint3d(x, y, 0);
      if (swapFlag) {
        textObj.Text =
          jcDataObj.Asu3 + "-" + jcDataObj.Asu2 + "-" + jcDataObj.Asu1;
      } else {
        textObj.Text =
          jcDataObj.Asu1 + "-" + jcDataObj.Asu2 + "-" + jcDataObj.Asu3;
      }
      textObj.fontSize = fontSize;
      textObj.dAngle = angle;
      if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("1")) {
        textObj.color = new McCmColor(255, 0, 0);
      }
      textObj.textType = "计算结果";
      textObj.draw(showType == 2);
      this.m_jcData.push(textObj.mcDbId);
    }

    if (jcDataObj.Asd1 && jcDataObj.Asd2 && jcDataObj.Asd3) {
      let textObj = new rlTextData();
      let x = ptCenter.x + gridVecPrep.x * (fontSize * 2 + 50);
      let y = ptCenter.y + gridVecPrep.y * (fontSize * 2 + 50);
      textObj.position = new McGePoint3d(x, y, 0);
      if (swapFlag) {
        textObj.Text =
          jcDataObj.Asd3 + "-" + jcDataObj.Asd2 + "-" + jcDataObj.Asd1;
      } else {
        textObj.Text =
          jcDataObj.Asd1 + "-" + jcDataObj.Asd2 + "-" + jcDataObj.Asd3;
      }
      textObj.fontSize = fontSize;
      textObj.dAngle = angle;
      if (jcDataObj.ProblemError && jcDataObj.ProblemError.includes("1")) {
        textObj.color = new McCmColor(255, 0, 0);
      }
      textObj.textType = "计算结果";
      textObj.draw(showType == 2);
      this.m_jcData.push(textObj.mcDbId);
    }
    store.commit("rlEntData/editEntityData", {
      Guid: this.Guid,
      classTypeName: this.classTypeName,
    });
  }
  eraseJcData() {
    if (this.m_jcData && this.m_jcData.length) {
      this.m_jcData.forEach((objId) => {
        objId?.getMcDbEntity().erase();
      });
      this.m_jcData = [];
    }
  }

  initData(obj) {
    super.initData(obj);

    this.m_gridData = obj.m_gridData;
    this.Ecc = obj.Ecc;
    this.HDiff1 = obj.HDiff1;
    this.HDiff2 = obj.HDiff2;
    this.Rotation = obj.Rotation;
    this.Color = obj.Color;
    // this.Layer = obj.Layer ? obj.Layer : "rlBeamSeg";
    this.LinkGuids = obj.LinkGuids;

    this.index2dData = obj.index2dData;
    this.index3dData = obj.index3dData;

    this.points = obj.points;
    this.useFunctionNames = obj.useFunctionNames ? obj.useFunctionNames : [];
    this.beamColor = obj.beamColor;
    this.subBeamColor = obj.subBeamColor;
    this.ringBeamColor = obj.ringBeamColor;
    this.m_RelationGuid = obj.m_RelationGuid ? obj.m_RelationGuid : null;
  }

  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.m_gridData = getEntityData({
      Guid: obj.m_gridData,
      classTypeName: "rlGrid",
    }); //rlAppObj.rlMxDrawObject.getMxEntity(obj.m_gridData);
    if (!this.m_gridData) {
      this.m_gridData = getEntityData({
        Guid: obj.m_gridData,
        classTypeName: "rlGridC",
      }); //rlAppObj.rlMxDrawObject.getMxEntity(obj.m_gridData);
    }
    this.Ecc = obj.Ecc;
    this.HDiff1 = obj.HDiff1;
    this.HDiff2 = obj.HDiff2;
    this.Rotation = obj.Rotation;
    this.useFunctionNames = JSON.parse(obj.useFunctionNames);
    this.m_RelationGuid = obj.m_RelationGuid;
    this.beamColor = obj.beamColor;
    this.subBeamColor = obj.subBeamColor;
    this.ringBeamColor = obj.ringBeamColor;
  }

  // 数据转换
  convert() {
    if (!this.isWasmGeted || (!this.index2dData && !this.index3dData)) {
      //
      // try {
      // 判断是否是圆弧墙
      let isArc = this.m_gridData.m_centerJoint;
      let ptCenter = null;
      let dRadius = 0;
      if (isArc) {
        ptCenter = this.m_gridData.mcDbGrid.center;
        dRadius = this.m_gridData.mcDbGrid.radius;
      }
      let res = getPKPM_BeamData(
        this.m_sectParamData.Kind,
        this.m_sectParamData.ShapeVal,
        this.m_gridData.m_stJoint.m_pt[0],
        this.m_gridData.m_stJoint.m_pt[1],
        this.m_gridData.m_edJoint.m_pt[0],
        this.m_gridData.m_edJoint.m_pt[1],
        this.LevelB,
        this.Height,
        this.Ecc,
        this.HDiff1,
        this.HDiff2,
        this.Rotation,
        isArc,
        ptCenter,
        dRadius,
        this.m_gridData.m_stJoint.HDiff
          ? Number(this.m_gridData.m_stJoint.HDiff)
          : 0,
        this.m_gridData.m_edJoint.HDiff
          ? Number(this.m_gridData.m_edJoint.HDiff)
          : 0
      );

      if (!res) return;
      let sameModelEnts = [];
      if (this.OtherData && typeof this.OtherData == "string") {
        let otherData = JSON.parse(this.OtherData);
        if (typeof otherData == "string") {
          otherData = JSON.parse(otherData);
        }
        if (otherData.sameModelEnts) {
          sameModelEnts = otherData.sameModelEnts;
        }
      }
      this.getModelDrawData(JSON.parse(res));

      let pt1 = new THREE.Vector3(...this.m_gridData.m_stJoint.m_pt);
      let pt2 = new THREE.Vector3(...this.m_gridData.m_edJoint.m_pt);
      this.OtherData.Length = pt1.distanceTo(pt2).toFixed(0);
      this.OtherData.sameModelEnts = sameModelEnts;
      // let wasmData = JSON.parse(res);
      // let data = `{"${this.Guid}":${JSON.stringify(wasmData)}}`;
      // let data3D = this.getModel3dData(data);
      // if (!data3D) return;

      // data3D = JSON.parse(data3D)["3D"][this.Guid];
      // this.points = data3D.Points;
      // this.index3dData = {
      //   points: data3D.Points,
      //   faces: data3D["3dFaces"].map((item) => item.index).flat(),
      // };
      // } catch (error) {
      //   console.log(
      //     "出错了！",
      //     error,
      //     this.m_sectParamData.Kind,
      //     this.m_sectParamData.ShapeVal,
      //     this.m_gridData.m_stJoint.m_pt[0],
      //     this.m_gridData.m_stJoint.m_pt[1],
      //     this.m_gridData.m_edJoint.m_pt[0],
      //     this.m_gridData.m_edJoint.m_pt[1],
      //     this.LevelB,
      //     this.Height,
      //     this.Ecc,
      //     this.HDiff1,
      //     this.HDiff2,
      //     this.Rotation
      //   );
      // }
    } else {
      if (typeof this.index2dData === "string") {
        this.index2dData = this.index2dData.split(",").map(Number);
      }
    }
  }

  // wasm截面数据转换
  // getModelDrawData(modelData) {
  //   this.index2dData = modelData["upViewData"];

  //   this.SectData = modelData["SectData"];
  //   this.OtherData = JSON.stringify(modelData);

  //   let drawing_3d = modelData["Drawing_3D"];

  //   this.points = drawing_3d.points;
  //   this.index3dData = {
  //     points: drawing_3d.points,
  //     faces: drawing_3d.faces,
  //   };
  // }

  // 克隆方法
  myClone() {
    let newObj = new rlBeamData();
    super.cloneData(newObj);
    newObj.m_gridData = this.m_gridData;
    newObj.Ecc = this.Ecc;
    newObj.HDiff1 = this.HDiff1;
    newObj.HDiff2 = this.HDiff2;
    newObj.Rotation = this.Rotation;
    newObj.Color = this.Color;
    newObj.points = this.points;
    newObj.useFunctionNames = this.useFunctionNames;
    newObj.m_RelationGuid = this.m_RelationGuid;
    newObj.beamColor = this.beamColor;
    newObj.subBeamColor = this.subBeamColor;
    newObj.ringBeamColor = this.ringBeamColor;
    return newObj;
  }

  // 绘制
  async draw() {
    if (this.m_sectParamData.ShapeVal) {
      let splitdata = this.m_sectParamData.ShapeVal.split(",");
      let sectString = splitdata.splice(1, splitdata.length - 3);
      sectString = sectString.join("*");
      this.m_sectGroupName = sectString;
      this.CurrtSect = sectString;
    }
    super.draw();
    this.m_gridData ? (this.m_gridData.m_beamId = this.Guid) : "";
    if (this.m_gridData && this.m_gridData.classTypeName == "rlGrid") {
      await this.m_gridData.drawCheckText();
    }
  }

  // 创建构件号文字--关联构件只显示一个构件号
  createModelNoText() {
    try {
      if (this.ModelNoTextObj && this.ModelNoTextObj.mcDbId)
        this.ModelNoTextObj.mcDbId.getMcDbEntity().erase();

      let visible =
        this.mcDbPolyline?.visible && store.state.displayData.modelNoDisplay;

      let sectSizeDisplay = store.state.displayData.sectSizeDisplay;
      let sectHeight = 0;
      if (sectSizeDisplay && this.m_TextObj) {
        sectHeight = this.m_TextObj.fontSize;
      }

      // console.log("this.Guid", this.Guid);
      let sameModelEnts = [];

      if (typeof this.OtherData == "string" && this.OtherData != "") {
        let otherData = JSON.parse(this.OtherData);

        // console.log("this.OtherData", otherData);
        if (typeof otherData == "string") {
          otherData = JSON.parse(otherData);
        }

        if (otherData.sameModelEnts) {
          sameModelEnts = otherData.sameModelEnts;
        } else {
          sameModelEnts = [this.Guid];
        }
      } else {
        if (this.OtherData.sameModelEnts) {
          sameModelEnts = this.OtherData.sameModelEnts;
        } else {
          sameModelEnts = [this.Guid];
        }
      }

      if (!sameModelEnts || !sameModelEnts.length) return;

      let beamlinePts = [];
      for (let i = 0; i < sameModelEnts.length; i++) {
        const beamGuid = sameModelEnts[i];
        let beamObj = getEntityData({
          Guid: beamGuid,
          classTypeName: "rlBeamSeg",
        });

        if (beamGuid !== this.Guid && !beamObj) {
          return; //关联构件还没渲染，不处理即可
        }

        beamlinePts.push(
          new THREE.Vector3(...beamObj.m_gridData.m_stJoint.m_pt)
        );
        beamlinePts.push(
          new THREE.Vector3(...beamObj.m_gridData.m_edJoint.m_pt)
        );
      }

      beamlinePts.sort(function (a, b) {
        if (a.x !== b.x) return a.x - b.x;
        if (a.y !== b.y) return a.y - b.y;
        return a.z - b.z;
      });

      let centerPoint = new THREE.Vector3().lerpVectors(
        beamlinePts[0],
        beamlinePts[beamlinePts.length - 1],
        0.5
      );
      if (this.m_gridData.m_centerJoint) {
        //计算圆弧中心点
        let tempCenterPoint = calculateArcCenterByCenter(
          new THREE.Vector3(...this.m_gridData.m_centerJoint.m_pt),
          beamlinePts[0],
          beamlinePts[beamlinePts.length - 1]
        );
        if (tempCenterPoint) {
          centerPoint = tempCenterPoint;
        }
      }

      let angle = 0;
      if (this.m_gridData && centerPoint) {
        //判断网格方向
        const pt1 = beamlinePts[0];
        const pt2 = beamlinePts[beamlinePts.length - 1];
        const vec = pt2.clone().sub(pt1);
        angle = vec.angleTo(new THREE.Vector3(1, 0, 0));

        //将构件号的位置偏移200mm
        let vecWidth = vec.cross(new THREE.Vector3(0, 0, 1));
        vecWidth.normalize();

        centerPoint.x += Math.abs(vecWidth.x) * (sectHeight + 500);
        centerPoint.y -= Math.abs(vecWidth.y) * (sectHeight + 500);
        if (this.m_gridData.m_centerJoint) {
          angle = 0;
        }
      }

      this.ModelNoTextObj = new rlTextData();
      this.ModelNoTextObj.position = centerPoint;
      this.ModelNoTextObj.Text = this.ModelNo;
      this.ModelNoTextObj.fontSize = this.fontSize;
      this.ModelNoTextObj.textType = "构件号";
      this.ModelNoTextObj.belongObjId = this.mcDbId;
      this.ModelNoTextObj.color = new McCmColor(255, 140, 0);
      this.ModelNoTextObj.dAngle = angle;
      this.ModelNoTextObj.draw(visible);
    } catch (error) {
      console.error("beamData createModelNoText:", this.Guid, error);
    }
  }

  // 创建字体
  createText() {
    if (this.m_TextObj) {
      this.m_TextObj.erase();
    }
    let visible =
      this.mcDbPolyline?.visible && store.state.displayData.sectSizeDisplay;
    let points = this.index2dData;
    if (!points) return;
    let sumX = 0;
    let sumY = 0;
    let maxX = -Infinity;
    let minX = Infinity;

    // 计算中心点
    for (let i = 0; i < points.length; i += 3) {
      const x = points[i];
      const y = points[i + 1];
      sumX += x;
      sumY += y;
      maxX = Math.max(maxX, x);
      minX = Math.min(minX, x);
    }

    // 计算中心点的xy坐标
    const centerX = sumX / (points.length / 3);
    const centerY = sumY / (points.length / 3);
    const centerPoint = new THREE.Vector3(centerX, centerY, 0);
    let angleText = 0;
    //判断网格方向
    const pt1 = new THREE.Vector3(...this.m_gridData.m_stJoint.m_pt);
    const pt2 = new THREE.Vector3(...this.m_gridData.m_edJoint.m_pt);
    let { angle } = calculateDistanceAndAngle(pt1, pt2);
    if (angle == 180) angle = 0;
    if (angle == 270) angle = 90;
    //转换成弧度
    angleText = angle * (Math.PI / 180);

    const vec = pt2.clone().sub(pt1).normalize();
    //将构件号的位置偏移200mm
    let vecWidth = vec.cross(new THREE.Vector3(0, 0, 1));
    vecWidth.normalize();

    centerPoint.x += Math.abs(vecWidth.x) * 200;
    centerPoint.y -= Math.abs(vecWidth.y) * 200;
    this.m_TextObj = new rlTextData();
    this.m_TextObj.position = centerPoint;
    this.m_TextObj.Text = this.m_sectGroupName;
    this.m_TextObj.fontSize = this.fontSize;
    this.m_TextObj.textType = "截面尺寸";
    this.m_TextObj.belongObjId = this.mcDbId;
    this.m_TextObj.dAngle = angleText;
    this.m_TextObj.draw(visible);
    this.m_TextObj.lineObjId = this.m_TextObj.mcDbId;
  }

  updateThisObj(obj, redraw = true) {
    //判断颜色是否变化
    let isColorChange = false;
    if (obj.m_sectParamData.IsRingBeamSeg == 1) {
      isColorChange = this.Color != this.ringBeamColor;
      this.Color = this.ringBeamColor;
    } else if (obj.Attribute == 1) {
      isColorChange = this.Color != this.beamColor;
      this.Color = this.beamColor;
    } else {
      isColorChange = this.Color != this.subBeamColor;
      this.Color = this.subBeamColor;
    }

    super.updateThisObj(obj, redraw || isColorChange);
  }

  transformBy(vecMove) {
    //判断移动方向是否与网格方向垂直
    let stPoint = new THREE.Vector3(...this.m_gridData.m_stJoint.m_pt);
    let edPoint = new THREE.Vector3(...this.m_gridData.m_edJoint.m_pt);
    let gridVec = new THREE.Vector3().subVectors(stPoint, edPoint);

    let dirReverse = false;
    if (
      // lineDirection.x * lineDirection.y <= 0 &&
      gridVec.x < -0.01 ||
      gridVec.y < -0.01
    ) {
      let tmp = stPoint;
      stPoint = edPoint;
      edPoint = tmp;
      gridVec = new THREE.Vector3().subVectors(stPoint, edPoint);
      dirReverse = true;
    }

    // 计算点积
    const dotProduct = gridVec.dot(vecMove);

    // 判断点积是否为零，考虑浮点数精度误差
    const epsilon = 1e-5; // 可以根据需要调整这个阈值
    const arePerpendicular = Math.abs(dotProduct) < epsilon;

    //计算梁的偏轴
    if (arePerpendicular) {
      //计算叉积
      const crossProduct = new THREE.Vector3().crossVectors(gridVec, vecMove);

      if (crossProduct.z < 0) {
        this.Ecc -= vecMove.length();
      } else {
        this.Ecc += vecMove.length();
      }
      let gridVecPrep = new THREE.Vector3();
      gridVecPrep.crossVectors(gridVec, new THREE.Vector3(0, 0, 1));
      if (dirReverse && gridVecPrep.x < 0 && gridVecPrep.y < 0) {
        this.Ecc = -this.Ecc;
      }

      // this.draw();
      // this.mcDbId = rlAppObj.mxcadObject.drawEntity(this.mcDbPolyline);
      // this.updateThisObj(this);
    }
  }
  // 返回图形源数据
  getDataBase() {
    let data = super.getDataBase();
    data["SectGuid"] = this.m_sectParamData.Guid;
    data["Attribute"] = this.m_sectParamData.IsRingBeamSeg ? 3 : this.Attribute;
    if (this.m_gridData) data["GridGuid"] = this.m_gridData.Guid;

    data["Ecc"] = this.Ecc;
    data["HDiff1"] = this.HDiff1;
    data["HDiff2"] = this.HDiff2;
    data["Rotation"] = this.Rotation;
    //剔除空值
    data["LinkGuids"] = this.LinkGuids?.flat().filter(Boolean).join(",");
    data["useFunctionNames"] = this.useFunctionNames?.join(",");
    data["RelationGuid"] = this.m_RelationGuid;
    return data;
  }

  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    let data = super.getDrawData();

    data["m_gridData"] = this.m_gridData.Guid;
    data["Ecc"] = this.Ecc;
    data["HDiff1"] = this.HDiff1;
    data["HDiff2"] = this.HDiff2;
    data["Rotation"] = this.Rotation;
    data["useFunctionNames"] = JSON.stringify(this.useFunctionNames);
    data["RelationGuid"] = this.m_RelationGuid;
    data["beamColor"] = this.beamColor;
    data["subBeamColor"] = this.subBeamColor;
    data["ringBeamColor"] = this.ringBeamColor;
    return data;
  }

  // 删除
  async erase() {
    this.m_gridData ? (this.m_gridData.m_beamId = null) : "";
    await checkRelationGuidData(this.Guid, "rlBeamSeg");
    this.eraseJcData();
    this.eraseCheckText();
    await super.erase();
  }
}

export { rlBeamData };
